import type { EditorState } from '#packages/stateManagement';

const getOverridden = (state: EditorState) => state.linkPanel.overridden;

export { getOverridden };
